import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import { _ } from 'underscore';
import { FormBuilder, FormControl } from '@angular/forms';
import { AdjustTimeService } from '../adjust-time.service';
import { ResidentialService } from '../questionnaire-residential/residential.service';
import { RecommendationService } from '../questionnaire-residential/recommendation/recommendation.service';
import { ServiceTypeComponent } from '../questionnaire-residential/signup-order/service-type/service-type.component';
@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.css'],
})
export class DatepickerComponent implements OnInit {
  @Input() pickerPlaceholder: string;
  @Input() inputValue;
  @Input() inputView;
  @Output() selectedItem = new EventEmitter();
  disabled = true;
  // myHolidayDates = [
  //   '12/24/2021',
  //   '12/25/2021',
  //   '12/31/2021',
  //   '1/17/2022',
  //   '4/15/2022',
  //   '5/30/2022',
  //   '7/4/2022',
  //   '9/5/2022',
  //   '11/24/2022',
  //   '11/25/2022',
  //   '12/24/2022',
  //   '12/26/2022',
  // ];
  disableWeekDays = [0, 6];

  inputViews: string;
  deviceWidth: any;
  validateText: string;
  daysOut: boolean;
  invalidFormat: boolean;
  blackOutDates: any = [];
  providerName = "";
  constructor(
    private timeZoneService: AdjustTimeService,
    private formBuilder: FormBuilder,
    private residentialService: ResidentialService,
    private recommendationService: RecommendationService,
    private serviceType: ServiceTypeComponent,
  ) {}
  datePickerForm = this.formBuilder.group({
    selectedValue: '',
  });
  minDate = this.timeZoneService.updateTime('America/Chicago');
  maxDate = new Date(new Date().setDate(new Date().getDate() + 60));

  ngOnInit(): void {

    
    var ProductID = "";
    var ESIID = "";
    var TDSP = "";
    try{

      
      const signUpProduct =
      this.recommendationService.signupProduct !== undefined
        ? this.recommendationService.signupProduct
        : JSON.parse(sessionStorage.getItem('signupProduct'));
      this.providerName =  signUpProduct.energy_provider;
      ProductID = signUpProduct.ProductID;
      // if(!_.isEmpty(sessionStorage.getItem('tdspIndicator')))
      // {
      //   ESIID = sessionStorage.getItem('tdspIndicator');
        
      // }

      TDSP = signUpProduct.utility_name;
      if(this.providerName == "APGE Energy" || this.providerName == "Gexa Energy" || this.providerName == "Frontier Utilities")
      {
        ESIID =  this.residentialService.tdspindicator;
      }

      if(this.providerName == "4Change Energy")
      {
        ESIID =  this.residentialService.esiid;
      }

      
      var aa = this.serviceType.hgSwitch;
      var bb = this.serviceType.hgService;

      var ismoving = true;
      if(bb.sp)
      {
        ismoving = false;
      }

      
    }
    catch
    {
      var a = "";
    }
    
    // this.residentialService.getBlackOutDates(this.providerName,ESIID,ismoving,ProductID,TDSP).subscribe((res) => {
    //   let blackOutDates;
    //   res[0].BlackOutDates.map((date) => {
    //     const dateValue = new Date(date);
    //     blackOutDates = `${
    //       dateValue.getMonth() + 1
    //     }/${dateValue.getDate()}/${dateValue.getFullYear()}`;
    //     this.blackOutDates.push(blackOutDates);
    //   });
      
    //   if(!_.isEmpty(res[0].ProviderData) && this.providerName == "APGE Energy")
    //   {
    //     this.disableWeekDays = [0];
    //     var avlist = [];
    //     res[0].ProviderData.allValidDates.map((x) => {
    //       avlist.push(new Date(x.date))
    //     });

    //     var blacklist = this.getDatesInRange(new Date(), new Date(res[0].ProviderData.maximumDate),avlist)
    //     //this.minDate = new Date(res[0].ProviderData.minimumDate)
    //     this.maxDate = new Date(res[0].ProviderData.maximumDate)
    //     this.blackOutDates = blacklist;
    //   }

    //   if(!_.isEmpty(res[0].ProviderData) && this.providerName == "4Change Energy")
    //   {
    //     this.disableWeekDays = [0];
    //     var dates = [];
    //     const extractedActions: string[][] = this._4ChangeExtractDate(res[0].ProviderData);
    //     // console.log("Priority_Move_In:", extractedActions[0]);
    //     // console.log("Self_Selected_Switch:", extractedActions[1]);
    //     if(this.serviceType.selectedSwitchValue == "Standard Move-In")
    //     {
    //       dates = extractedActions[0];
    //     }
    //     else
    //     {
    //       dates = extractedActions[1];
    //     }

    //     var avlist = [];
    //     dates.map((x) => {
    //       avlist.push(new Date(x))
    //     });
        
    //     var blacklist = this.getDatesInRange(new Date(), new Date(dates[dates.length - 1]),avlist)
    //     //this.minDate = new Date(res[0].ProviderData.minimumDate)
    //     this.maxDate = new Date(dates[dates.length - 1])
    //     this.blackOutDates = blacklist;
       
       
    //   }


    //   if(!_.isEmpty(res[0].ProviderData) && (this.providerName == "Gexa Energy" || this.providerName == "Frontier Utilities"))
    //   {
    //     this.disableWeekDays = [0];
    //     var dates = [];
    //     const extractedActions: string[][] = this.GexaExtractDate(res[0].ProviderData);
    //     // console.log("Priority_Move_In:", extractedActions[0]);
    //     // console.log("Self_Selected_Switch:", extractedActions[1]);
    //     dates = extractedActions[0];

    //     var avlist = [];
    //     dates.map((x) => {
    //       avlist.push(new Date(x))
    //     });
        
    //     var blacklist = this.getDatesInRange(new Date(), new Date(dates[dates.length - 1]),avlist)
    //     //this.minDate = new Date(res[0].ProviderData.minimumDate)
    //     this.maxDate = new Date(dates[dates.length - 1])
    //     this.blackOutDates = blacklist;
       
       
    //   }

    // });

    this.blackOutDates = this.residentialService.REP_Holiday_Dates;
    if(this.providerName == "APGE Energy" || this.providerName == "Gexa Energy" || this.providerName == "Frontier Utilities" || this.providerName == "Rhythm Energy" || this.providerName == "Energy Texas" )
      {

        if(ismoving)
        {
          if(this.residentialService.REP_movin_Dates != null && this.residentialService.REP_movin_Dates.length != 0)
          {
            this.disableWeekDays = [0];
            this.maxDate = new Date(this.residentialService.REP_Move_Max_Date)
            this.blackOutDates = this.residentialService.REP_movin_Dates;
            this.minDate = this.residentialService.REP_Move_Min_Date != undefined ?  this.residentialService.REP_Move_Min_Date : this.minDate;
          }
         
        }
        else
        {

          if(this.residentialService.REP_switch_Dates != null && this.residentialService.REP_switch_Dates.length != 0)
          {
            this.disableWeekDays = [0];
            this.maxDate = new Date(this.residentialService.REP_SWI_Max_Date)
            this.blackOutDates = this.residentialService.REP_switch_Dates;
            this.minDate = this.residentialService.REP_SWI_Min_Date != undefined ?  this.residentialService.REP_SWI_Min_Date : this.minDate;

          }
          
        }
       
      }

      if(this.providerName == "4Change Energy")
      {
        

        if(this.serviceType.selectedSwitchValue == "Standard Move-In")
        {
          if(this.residentialService.REP_movin_Dates != null && this.residentialService.REP_movin_Dates.length != 0)
          {
            this.disableWeekDays = [0];
            this.maxDate = new Date(this.residentialService.REP_Move_Max_Date)
            this.blackOutDates = this.residentialService.REP_movin_Dates;
          }
         
        }
        else
        {
          if(this.residentialService.REP_switch_Dates != null && this.residentialService.REP_switch_Dates.length != 0)
          {
            this.disableWeekDays = [0];
            this.maxDate = new Date(this.residentialService.REP_SWI_Max_Date)
            this.blackOutDates = this.residentialService.REP_switch_Dates;
          }
          
        }

  
       
      }

      if(this.providerName == "BKV Energy")
      {
        
      //  this.maxDate = new Date(new Date().setDate(new Date().getDate() + 44));
      //   if(ismoving)
      //   {
      //     let currentDate = new Date(),
      //     endDate,
      //     noOfDaysToAdd = 2,
      //     count = 0;
      //     while (count < noOfDaysToAdd) {
      //     endDate = new Date(currentDate.setDate(currentDate.getDate() + 1));
      //     if (endDate.getDay() != 0 && endDate.getDay() != 6) {
      //       count++;
      //     }
      //   }
      //  var Dates = new Date(this.suffixZeroToSelectedSwitchDate(endDate));

      //  const year = Dates.getFullYear();
      //  const month = String(Dates.getMonth() + 1).padStart(2, '0'); // Add 1 to month since it's zero-based
      //  const day = String(Dates.getDate()).padStart(2, '0');
       
      //  // Create the formatted date string in 'YYYY-MM-DD' format
      //  this.minDate = `${year}-${month}-${day}`;
      //   }

        if(ismoving)
        {
          this.maxDate = this.residentialService.REP_Move_Max_Date;
          this.minDate = this.residentialService.REP_Move_Min_Date;
        }
        else
        {
          this.maxDate = this.residentialService.REP_SWI_Max_Date;
          this.minDate = this.residentialService.REP_SWI_Min_Date;
        }
  
       
      }

      if(this.providerName == "Chariot Energy")
      {

        this.disableWeekDays = [0];
        // this.maxDate = new Date(new Date().setDate(new Date().getDate() + 59));
       
        //   let currentDate = new Date(),
        //   endDate,
        //   noOfDaysToAdd = ismoving ? 1 : 2,
        //   count = 0;
        //   while (count < noOfDaysToAdd) {
        //   endDate = new Date(currentDate.setDate(currentDate.getDate() + 1));
        //   if (endDate.getDay() != 0) {
        //     count++;
        //   }
        // }
        // var Dates = new Date(this.suffixZeroToSelectedSwitchDate(endDate));

        // const year = Dates.getFullYear();
        // const month = String(Dates.getMonth() + 1).padStart(2, '0'); // Add 1 to month since it's zero-based
        // const day = String(Dates.getDate()).padStart(2, '0');
        
        // // Create the formatted date string in 'YYYY-MM-DD' format
        // this.minDate = `${year}-${month}-${day}`;
        if(ismoving)
        {
          this.maxDate = this.residentialService.REP_Move_Max_Date;
          this.minDate = this.residentialService.REP_Move_Min_Date;
        }
        else
        {
          this.maxDate = this.residentialService.REP_SWI_Max_Date;
          this.minDate = this.residentialService.REP_SWI_Min_Date;
        }
       
      }




    this.deviceWidth = window.innerWidth;
    this.inputViews = this.deviceWidth < 768 ? 'mobile' : 'web';
    console.log(this.daysOut);
    if (this.inputValue === undefined)
      this.inputValue = this.residentialService.dateModel;
    if (typeof this.inputValue === 'string') {
      this.inputValue = new Date(this.inputValue);
    }
    if (this.inputValue != undefined) {
        this.datePickerForm.setValue({ selectedValue: this.inputValue });

    }
  }

  myFilter = (d: Date): boolean => {
    const day = (d || new Date()).getDay();
    return this.blackOutDates.find(
      (row) =>
        new Date(row).getDate() === new Date(d).getDate() &&
        new Date(row).getFullYear() === new Date(d).getFullYear() &&
        new Date(row).getMonth() === new Date(d).getMonth()
    ) || this.disableWeekDays.includes(day)
      ? false
      : true;
  };

  valueChanged() {
    this.selectedItem.emit(this.datePickerForm.value);
  }

  validateDate() {
    return !this.datePickerForm.value.selectedValue
      ? 'Please format your response as MM/DD/YYYY'
      : this.datePickerForm.value.selectedValue > this.maxDate
      ? 'We can only process requests up to 60 days out'
      : new Date(this.datePickerForm.value.selectedValue) <
        new Date(this.minDate) && this.providerName != "APGE Energy" && this.providerName != "4Change Energy"  && this.providerName != "Frontier Utilities"  && this.providerName != "Gexa Energy"
      ? 'Please enter a future date up to 60 days out'
      : '';
  }

  dateKeyUpFormat(e) {
    if (e.which !== 8) {
      var numChars = e.target.value.length;
      if (numChars === 2 || numChars === 5) {
        var thisVal = e.target.value;
        thisVal += '/';
        e.target.value = thisVal;
      }
    }
  }

  getDatesInRange(
    startDate: Date,
    endDate: Date,
    excludedDates: Date[] = []
  ): Date[] {
    const datesInRange: Date[] = [];
    let currentDate = new Date(startDate);
  
    const compareDates = (date1: Date, date2: Date): boolean => {
      return (
        date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate()
      );
    };
  


    while (currentDate <= endDate) {
      // const dateExistsInExcludedList = excludedDates.some(
      //   (excludedDate) => currentDate.getTime() === excludedDate.getTime()
      // );

      const dateExistsInExcludedList = excludedDates.some(
        (excludedDate) => compareDates(currentDate, excludedDate)
      );
  
      if (!dateExistsInExcludedList) {
        datesInRange.push(new Date(currentDate));
      }
  
      currentDate.setDate(currentDate.getDate() + 1);
    }
  
    return datesInRange;
  }


  _4ChangeExtractDate(data): string[][] {
    const actions: string[][] = [[], [], []]; // Array to hold the three arrays

    // Iterate through the data
    
    data.GetTduEnrollmentDatesResult.Dates.EnrollmentDate.forEach(dateItem => {
            // Iterate through actions for each date and add to respective array
            dateItem.Actions.string.forEach((action, index) => {
                if (action === "Priority_Move_In") {
                    actions[0].push(dateItem.Date);
                } else if (action === "Self_Selected_Switch") {
                    actions[1].push(dateItem.Date);
                } else if (action === "Standard_Move_In") {
                    actions[0].push(dateItem.Date);
                }
            });
        });
    

    return actions;
}

GexaExtractDate(data): string[][] {
  const actions: string[][] = [[], [], []]; // Array to hold the three arrays

  // Iterate through the data
  
data.GetAvailableStartDatesResult.AvailableStartDateDetails.AvailableStartDateDetails.forEach(dateItem => {
          // Iterate through actions for each date and add to respective array
    actions[0].push(dateItem.MoveDate);
 });
  

  return actions;
}
  
suffixZeroToSelectedSwitchDate(d) {
  let newDate;
  if (new Date(d) < new Date()) d = new Date();
  newDate = this.setDateValueFor4CE(
    `${d.getMonth() + 1}`,
    `${d.getDate()}`,
    `${d.getFullYear()}`
  );
  return newDate;
}

setDateValueFor4CE(month, day, year) {
  return `${this.pad(month)}/${this.pad(day)}/${year}`;
}
pad(number) {
  return (number < 10 ? '0' : '') + number;
}

}
